import React from 'react'
import { ConfigClientType } from '../types/ConfigClientType'
import { showEmailButton } from '../lib/buttons'
import { getTranslation } from '../../constants/languages'
import { IconEmailMenu } from '../common/svgicons/EmailMenuButton'

type EmailMenuButtonProps = {
    iimclient: ConfigClientType;
    toggleMenu: Function;
}

const Translations = {
  lang_no: 'Åpne alternativer for å skrive til os',
  lang_se: 'Öppna alternativ till att mejla',
  lang_dk: 'Åben e-mailfunktion',
  lang_fi: 'Avaa sähköposti-vaihtoehto',
  lang_en: 'Open email option'
}

// No page exceptions found so far
const PageExceptions = {}

const EmailMenuButton = ({ iimclient, toggleMenu }: EmailMenuButtonProps) => {
  const lang = { iimclient }
  const translation = getTranslation(lang, Translations)

  const handleClick = () => toggleMenu('email')
  const handleKeyDown = ({ keyCode }) => (keyCode === 13 || keyCode === 32) && toggleMenu('email')

  return showEmailButton(iimclient) && (
    <div
      className="content-button action email-button"
      tabIndex={0}
      role="menuitem"
      aria-label={translation}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      >
      <IconEmailMenu width="24px" height="24px" color="#333" />
    </div>
  )
}

export default EmailMenuButton;
